import CustomInput from '../reusable/input';
import { DeleteOutlined } from '@mui/icons-material';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';


interface TextFieldProps {
    createMessageHandler: (message: string, baseUrl: string | null) => Promise<void>;
    loaders: boolean
}

const TextFieldSection = ({ createMessageHandler, loaders }: TextFieldProps) => {
    const [message, setMessage] = useState<string>('');
    const [selectedFileBase64, setSelectedFileBase64] = useState<string | null>(null);
    const [selectedFileName, setSelectedFileName] = useState<string | null>(null);

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const base64String = reader.result as string;
                setSelectedFileBase64(base64String);
                setSelectedFileName(file.name);
            };
            reader.readAsDataURL(file);
            event.target.value = '';
        }
    };

    const createMessage = () => {
        const cleanMessage = message.replace(/<(?:.|\n)*?>/gu, '').trim();
        if (selectedFileBase64 || cleanMessage) {
        createMessageHandler(message, selectedFileBase64);
        setMessage('');
        setSelectedFileBase64(null);
        setSelectedFileName(null);
        } else {
            toast.error('Please enter a message and select a file.', {
                position: 'top-left',
                autoClose: 5000,
                theme: 'dark'
            });
        }
    };

    const removeFile = () => {
        setSelectedFileBase64(null);
        setSelectedFileName(null);
    };

    const getFileIcon = (fileName: string | null) => {
        if (!fileName) return null;
        const fileExtension = fileName.split('.').pop()
            ?.toLowerCase();
        if (fileExtension === 'pdf') return '📄';
        if (['doc', 'docx'].includes(fileExtension || '')) return '📄';
        if (['xls', 'xlsx'].includes(fileExtension || '')) return '📊';
        if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension || '')) return '🖼️';
        return '📁';
    };

    return (
        <Box>
            <Box className="text-editor" width="100%" height="12vh">
                <CustomInput
                    type="quill"
                    value={message}
                    name="message"
                    placeholder="Type content here..."
                    quillHeight="8vh"
                    onChangeForPhone={(value: string) => (loaders ? null : setMessage(value))}
                />
                {/* <CustomToolbar shouldBorderFromTop={false} />
                <ReactQuill
                    onChange={(content) => (loaders ? null : setMessage(cleanHTML(content)))}
                    value={message}
                    placeholder="Type content here..."
                    modules={quillModule}
                    formats={quillFormats}
                    theme="snow"
                    style={{
                        height: '8vh',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px'
                        // border:  ? `1px solid ${red[300]}` : 'none'
                    }}
                /> */}
            </Box>
            {selectedFileBase64 && (
                <Box display="flex" alignItems="center" mt={1}>
                    {/* <InsertDriveFile /> */}
                    <Typography variant="body2" ml={1}>
                        {getFileIcon(selectedFileName)} {selectedFileName}
                    </Typography>
                    <IconButton onClick={removeFile} size="small" sx={{ ml: 1 }}>
                        <DeleteOutlined color="error" />
                    </IconButton>
                </Box>
            )}
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                <label htmlFor="file-upload">
                    <Button variant="outlined" disabled={loaders} component="span">
                        Upload File
                    </Button>
                </label>
                <input
                    id="file-upload"
                    type="file"
                    hidden
                    onChange={handleFileUpload}
                    key={selectedFileName || ''}
                />
                <Button
                    variant="contained"
                    disabled={(message.trim() === '' && !selectedFileBase64) || loaders}
                    onClick={createMessage}
                >
                    Send
                </Button>
            </Box>
        </Box>
    );
};

export default TextFieldSection;
